import { entropyToMnemonic } from '@ethersproject/hdnode'

export default function generateMnemonicFromAddress(address) {
    return entropyToMnemonic(address)
        .split(' ')
        .slice(0, 3)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
}
